<template>
  <div class="my-item-out-audit-orders-container">
    <ds-page-header :title="$t('myItemOutAuditOrders.page.title')" :subtitle="$t('myItemOutAuditOrders.page.subtitle')">
      <template #extra>
        <el-button size="small" icon="el-icon-back" @click="goBack">{{ $t('myItemOutAuditOrders.back') }}</el-button>
        <el-button type="primary" size="small" icon="el-icon-refresh" @click="_queryAuditOrdersMethod">
          {{ $t('myItemOutAuditOrders.refresh') }}
        </el-button>
      </template>
    </ds-page-header>

    <div class="ds-panel">
      <ds-toolbar :total="total" :density="density" :show-column-setting="false" :show-refresh="true"
        @update:density="density = $event" @refresh="_queryAuditOrdersMethod">
        <template #left><span class="ds-panel__title">{{ $t('myItemOutAuditOrders.title') }}</span></template>
      </ds-toolbar>
      <ds-data-table :data="auditOrdersInfo.auditOrders" :loading="loading" :error="hasError"
        :error-message="errorMessage" :density="density" border stripe
        :empty-description="$t('myItemOutAuditOrders.page.empty')" @retry="_queryAuditOrdersMethod">
        <el-table-column prop="applyOrderId" :label="$t('myItemOutAuditOrders.orderNo')" align="center" min-width="140">
          <template slot-scope="scope"><span class="ds-num">{{ scope.row.applyOrderId || '-' }}</span></template>
        </el-table-column>
        <el-table-column prop="resOrderTypeName" :label="$t('myItemOutAuditOrders.orderType')" align="center" min-width="110">
          <template slot-scope="scope"><ds-status-tag size="sm" type="info" :label="scope.row.resOrderTypeName || '-'" /></template>
        </el-table-column>
        <el-table-column prop="stateName" :label="$t('myItemOutAuditOrders.orderStatus')" align="center" width="110">
          <template slot-scope="scope"><ds-status-tag size="sm" type="muted" :label="scope.row.stateName || '-'" /></template>
        </el-table-column>
        <el-table-column prop="userName" :label="$t('myItemOutAuditOrders.applicant')" align="center" min-width="100" />
        <el-table-column prop="createTime" :label="$t('myItemOutAuditOrders.createTime')" align="center" width="170">
          <template slot-scope="scope"><span class="ds-num">{{ scope.row.createTime || '-' }}</span></template>
        </el-table-column>
        <el-table-column :label="$t('myItemOutAuditOrders.operation')" align="center" width="300" fixed="right">
          <template slot-scope="scope">
            <el-button size="mini" @click="_openDetailPurchaseApplyModel(scope.row)">{{ $t('myItemOutAuditOrders.view') }}</el-button>
            <el-button size="mini" v-if="scope.row.createUserId === auditOrdersInfo.currentUserId" @click="_openEditPurchaseModel(scope.row)">{{ $t('myItemOutAuditOrders.edit') }}</el-button>
            <el-button size="mini" type="primary" v-if="scope.row.curTaskName === '仓库管理员'" @click="_distributionOrder(scope.row)">{{ $t('myItemOutAuditOrders.itemDistribution') }}</el-button>
            <el-button size="mini" type="success" v-else @click="_openAuditOrderModel(scope.row)">{{ $t('myItemOutAuditOrders.audit') }}</el-button>
          </template>
        </el-table-column>
      </ds-data-table>
      <ds-pagination-bar :page="currentPage" :size="pageSize" :total="total"
        @size-change="handleSizeChange" @current-change="handleCurrentChange" />
    </div>
  </div>
</template>

<script>
import { getCollectionAuditOrder } from '@/api/resource/myItemOutAuditOrdersApi'
import { getCommunityId } from '@/api/community/communityApi'
import { getUserId } from '@/api/user/userApi'
import DsPageHeader from '@/components/ds/ds-page-header.vue'
import DsToolbar from '@/components/ds/ds-toolbar.vue'
import DsDataTable from '@/components/ds/ds-data-table.vue'
import DsPaginationBar from '@/components/ds/ds-pagination-bar.vue'
import DsStatusTag from '@/components/ds/ds-status-tag.vue'

export default {
  name: 'MyItemOutAuditOrdersList',
  components: { DsPageHeader, DsToolbar, DsDataTable, DsPaginationBar, DsStatusTag },
  data() {
    return {
      loading: false,
      hasError: false,
      errorMessage: '',
      density: 'default',
      DEFAULT_PAGE: 1,
      DEFAULT_ROWS: 10,
      currentPage: 1,
      pageSize: 10,
      total: 0,
      auditOrdersInfo: {
        auditOrders: [],
        total: 0,
        records: 1,
        moreCondition: false,
        userName: '',
        currentUserId: '',
        conditions: { AuditOrdersId: '', userName: '', auditLink: '', page: 1, row: 10 },
        orderInfo: '',
        procure: false,
        audit: '1'
      }
    }
  },
  created() {
    this.auditOrdersInfo.currentUserId = getUserId()
    this._listAuditOrders(this.DEFAULT_PAGE, this.DEFAULT_ROWS)
  },
  methods: {
    async _listAuditOrders(page, rows) {
      this.auditOrdersInfo.audit = '1'
      this.auditOrdersInfo.conditions.page = page
      this.auditOrdersInfo.conditions.row = rows
      const params = {
        ...this.auditOrdersInfo.conditions,
        communityId: getCommunityId()
      }
      try {
        this.loading = true
        this.hasError = false
        const { data, total } = await getCollectionAuditOrder(params)
        this.auditOrdersInfo.total = total
        this.auditOrdersInfo.records = total
        this.auditOrdersInfo.auditOrders = data
        this.total = total
      } catch (error) {
        console.error('请求失败:', error)
        this.hasError = true
        this.errorMessage = this.$t('common.loadError')
      } finally {
        this.loading = false
      }
    },
    _openAuditOrderModel(auditOrder) {
      this.$router.push({
        path: '/views/resource/purchaseApplyDetail',
        query: {
          applyOrderId: auditOrder.applyOrderId,
          resOrderType: auditOrder.resOrderType,
          flowId: auditOrder.flowId,
          action: 'audit',
          taskId: auditOrder.taskId
        }
      })
    },
    _queryAuditOrdersMethod() {
      this._listAuditOrders(this.DEFAULT_PAGE, this.DEFAULT_ROWS)
    },
    _openDetailPurchaseApplyModel(purchaseApply) {
      this.$router.push({
        path: '/views/resource/purchaseApplyDetail',
        query: {
          applyOrderId: purchaseApply.applyOrderId,
          resOrderType: purchaseApply.resOrderType
        }
      })
    },
    _openEditPurchaseModel(purchaseApply) {
      this.$router.push({
        path: '/pages/resource/editPurchaseApply',
        query: {
          applyOrderId: purchaseApply.applyOrderId,
          resOrderType: purchaseApply.resOrderType
        }
      })
    },
    _distributionOrder(purchaseApply) {
      this.$router.push({
        path: '/pages/admin/resourceOutManage',
        query: {
          applyOrderId: purchaseApply.applyOrderId,
          resOrderType: purchaseApply.resOrderType,
          taskId: purchaseApply.taskId,
          flowId: purchaseApply.flowId
        }
      })
    },
    goBack() {
      this.$router.go(-1)
    },
    handleSizeChange(val) {
      this.pageSize = val
      this._listAuditOrders(this.currentPage, val)
    },
    handleCurrentChange(val) {
      this.currentPage = val
      this._listAuditOrders(val, this.pageSize)
    }
  }
}
</script>

<style lang="scss" scoped>
.my-item-out-audit-orders-container { padding: var(--ds-spacing-lg); background-color: var(--ds-gray-100); min-height: calc(100vh - 60px); }
.ds-panel { background: #fff; border: 1px solid var(--ds-gray-300); border-radius: var(--ds-radius-md); box-shadow: var(--ds-shadow-sm); overflow: hidden; margin-bottom: var(--ds-spacing-lg);
  &__title { font-size: var(--ds-font-size-lg); font-weight: 600; color: var(--ds-gray-800); } }
</style>
